import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function Drakkar({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 100 100"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path
				fill="#CD0400"
				d="M29.09 95.91c-3.32-.29-8.19-1.27-13.08-4.33-2.29-1.44-6.11-3.84-8.72-8.74-2.65-4.98-2.66-9.91-2.2-13.16.61-3.54 1.32-7.07 2.11-10.54.55-2.43 1.15-4.85 1.78-7.2A5.187 5.187 0 0 1 3 46.82c0-2.85 2.32-5.18 5.18-5.18.61 0 1.2.11 1.76.32l.32.12 5.36 8.93-.31.51c-3.36 5.58-3.36 12.39 0 17.77 4.55 7.3 12.89 7.86 13.83 7.89h41.78c.9-.04 9.24-.59 13.79-7.89 3.35-5.38 3.35-12.19 0-17.77L84.4 51l2.45-4.08.12-.22 2.79-4.63.32-.12c.55-.21 1.14-.32 1.76-.32a5.181 5.181 0 1 1-.8 10.3c.63 2.36 1.22 4.77 1.78 7.2.79 3.46 1.5 7 2.1 10.51.47 3.28.46 8.2-2.19 13.19-2.6 4.9-6.43 7.3-8.71 8.74-4.88 3.07-9.76 4.05-12.99 4.33h-41.9z"
			/>
			<path
				fill="#fff"
				d="M91.82 42.64c2.31 0 4.18 1.87 4.18 4.18S94.13 51 91.82 51c-.94 0-1.81-.31-2.51-.85l.42.85c.73 2.68 1.43 5.47 2.09 8.36.83 3.62 1.52 7.11 2.09 10.45.29 2.06.74 7.22-2.09 12.55-2.48 4.66-6.14 6.96-8.36 8.36-4.91 3.08-9.7 3.93-12.55 4.18H29.09c-2.84-.25-7.63-1.1-12.55-4.18-2.23-1.4-5.89-3.7-8.36-8.36-2.83-5.32-2.38-10.49-2.09-12.55.57-3.35 1.27-6.84 2.09-10.45.66-2.9 1.36-5.69 2.09-8.36l.42-.85c-.7.53-1.57.85-2.51.85C5.87 51 4 49.13 4 46.82s1.87-4.18 4.18-4.18c.49 0 .96.08 1.4.25 1.62 2.7 3.25 5.41 4.87 8.11-3.52 5.85-3.53 13.15 0 18.82 4.88 7.84 13.88 8.33 14.64 8.36h41.82c.75-.03 9.75-.52 14.64-8.36 3.53-5.67 3.52-12.96 0-18.82l2.14-3.57.14-.24 2.59-4.31c.44-.17.91-.25 1.4-.25m0-1.99c-.74 0-1.45.13-2.11.38l-.65.25-.36.59-2.59 4.31v.02l-.03.02-.12.22-2.13 3.54-.62 1.03.62 1.03c3.12 5.18 3.12 11.75.02 16.73-4.22 6.77-11.93 7.37-12.98 7.42H29.14c-1.05-.05-8.77-.65-12.98-7.42-3.11-4.98-3.1-11.55.02-16.73L16.8 51l-.62-1.03-1.35-2.25-3.52-5.86-.36-.59-.65-.25c-.67-.25-1.38-.38-2.11-.38-3.41 0-6.18 2.77-6.18 6.18s2.5 5.9 5.68 6.16q-.765 2.94-1.44 5.94c-.8 3.49-1.51 7.04-2.11 10.56v.06c-.48 3.4-.48 8.54 2.31 13.77 2.73 5.13 6.69 7.62 9.06 9.11 4 2.51 8.65 4.06 13.44 4.48h42.17c4.79-.43 9.44-1.98 13.43-4.49 2.38-1.49 6.34-3.99 9.07-9.12 2.78-5.22 2.79-10.37 2.3-13.77v-.06c-.6-3.52-1.31-7.07-2.11-10.56-.45-1.99-.94-3.98-1.44-5.94 3.17-.26 5.68-2.92 5.68-6.16 0-3.41-2.77-6.18-6.18-6.18z"
			/>
			<path
				fill="#AF0805"
				d="M91.82 51c-.94 0-1.81-.31-2.51-.85l.42.85c.73 2.68 1.43 5.47 2.09 8.36.83 3.62 1.52 7.11 2.09 10.45.29 2.06.74 7.22-2.09 12.55-2.48 4.66-6.14 6.96-8.36 8.36-4.91 3.08-9.7 3.93-12.55 4.18H50V78.17h20.91c.75-.03 9.75-.52 14.64-8.36 3.53-5.67 3.52-12.96 0-18.82l2.14-3.57.14-.24 2.59-4.31c.44-.17.91-.25 1.4-.25 2.31 0 4.18 1.87 4.18 4.18s-1.87 4.18-4.18 4.18z"
			/>
			<path
				stroke="#fff"
				strokeLinecap="round"
				strokeMiterlimit={10}
				strokeWidth={4}
				d="M50 5v73.18"
			/>
			<path
				fill="#000"
				d="M33.27 83.45c-2.91 0-5.27-2.37-5.27-5.27s2.37-5.27 5.27-5.27 5.27 2.37 5.27 5.27-2.37 5.27-5.27 5.27"
			/>
			<path
				fill="#14F3C4"
				d="M33.27 73.91c2.36 0 4.27 1.92 4.27 4.27a4.28 4.28 0 0 1-4.27 4.27A4.28 4.28 0 0 1 29 78.18a4.28 4.28 0 0 1 4.27-4.27m0-2c-3.46 0-6.27 2.81-6.27 6.27s2.81 6.27 6.27 6.27 6.27-2.81 6.27-6.27-2.81-6.27-6.27-6.27"
			/>
			<path
				fill="#000"
				d="M50 83.45c-2.91 0-5.27-2.37-5.27-5.27s2.37-5.27 5.27-5.27 5.27 2.37 5.27 5.27-2.37 5.27-5.27 5.27"
			/>
			<path
				fill="#14F3C4"
				d="M50 73.91c2.36 0 4.27 1.92 4.27 4.27A4.28 4.28 0 0 1 50 82.45a4.28 4.28 0 0 1-4.27-4.27A4.28 4.28 0 0 1 50 73.91m0-2c-3.46 0-6.27 2.81-6.27 6.27s2.81 6.27 6.27 6.27 6.27-2.81 6.27-6.27-2.81-6.27-6.27-6.27"
			/>
			<path
				fill="#000"
				d="M66.73 83.45c-2.91 0-5.27-2.37-5.27-5.27s2.37-5.27 5.27-5.27S72 75.28 72 78.18s-2.37 5.27-5.27 5.27"
			/>
			<path
				fill="#14F3C4"
				d="M66.73 73.91c2.36 0 4.27 1.92 4.27 4.27a4.28 4.28 0 0 1-4.27 4.27 4.28 4.28 0 0 1-4.27-4.27 4.28 4.28 0 0 1 4.27-4.27m0-2c-3.46 0-6.27 2.81-6.27 6.27s2.81 6.27 6.27 6.27S73 81.64 73 78.18s-2.81-6.27-6.27-6.27"
			/>
			<path fill="#CD0400" d="M12.36 48.91H8.18V51h4.18z" />
			<path fill="#AF0805" d="M91.82 48.91h-4.18V51h4.18z" />
			<path
				fill="#CD0400"
				d="M69.97 59.36H25.12c.06-.09.12-.2.2-.32 9.05-12.94 9.05-30.34 0-43.29-.08-.11-.14-.22-.2-.31h44.82s.06.03.07.04c10.75 12.47 10.75 31.35-.04 43.87z"
			/>
			<path
				fill="#CD0400"
				d="M78.06 36.83c.03 1.63-.06 3.27-.26 4.89-.15 1.11-.33 2.21-.6 3.28-.55 2.45-1.38 4.84-2.5 7.13-1.22 2.56-2.8 4.99-4.74 7.21-.01 0-.02.01-.03.01H25.12c.05-.09.13-.2.2-.31a37 37 0 0 0 5.39-11.45c.32-1.15.59-2.32.79-3.49.31-1.71.5-3.45.56-5.19.04-.9.04-1.8.01-2.7a36 36 0 0 0-.38-4.26c-.1-.76-.24-1.54-.4-2.29-.25-1.24-.56-2.47-.95-3.68-.21-.67-.44-1.34-.69-2-.41-1.1-.88-2.17-1.4-3.23-.28-.6-.6-1.19-.92-1.77-.54-.98-1.13-1.93-1.77-2.86-.08-.13-.17-.26-.26-.39-.08-.1-.15-.21-.2-.3h44.82s.05.03.07.04c.02.02.03.04.05.06.72.85 1.4 1.71 2.02 2.61.38.53.73 1.08 1.07 1.63.61.97 1.15 1.98 1.63 3a30.446 30.446 0 0 1 2 5.31c.21.7.39 1.42.54 2.14.28 1.33.49 2.68.61 4.03.08.85.13 1.7.14 2.55z"
			/>
			<path
				fill="#000"
				d="M77.32 30.26 67.29 40.29l-5 5.01-14.08 14.07h-2.69l31.25-31.25c.21.7.39 1.42.54 2.14zM77.8 41.73c-.15 1.11-.33 2.21-.6 3.28L62.85 59.36h-2.69l2.13-2.13 15.5-15.5zM78.059 36.83l-3.45 3.45-12.32 12.33-6.75 6.75h-2.7l19.08-19.08 6-6c.08.85.13 1.7.14 2.55M74.699 52.14c-1.22 2.56-2.8 4.99-4.74 7.21-.01 0-.02.01-.03.01h-2.46l7.22-7.22zM62.859 15.45 30.709 47.6c.32-1.15.59-2.32.79-3.49l1.52-1.52 2.32-2.31 24.83-24.83zM73.149 19.8l-20.48 20.48-19.09 19.08h-2.69l19.08-19.08 12.33-12.32 9.79-9.8c.38.53.73 1.08 1.07 1.63zM70.06 15.56l-7.77 7.78-36.02 36.02h-1.15c.05-.09.13-.2.2-.31.85-1.2 1.61-2.46 2.3-3.73l5.4-5.41 9.64-9.63 19.63-19.63 5.19-5.2h2.46s.05.03.07.04c.02.02.03.04.05.06zM75.6 24.66 59.98 40.28 40.89 59.36H38.2l24.09-24.09L74.77 22.8c.3.62.57 1.23.83 1.86M33.59 15.45l-5.32 5.32c-.28-.6-.6-1.19-.92-1.77l3.55-3.55zM48.219 15.45l-16.52 16.52c-.1-.76-.24-1.54-.4-2.29l1.71-1.71 12.5-12.51h2.7zM40.9 15.45 30.35 26c-.21-.67-.44-1.34-.69-2l8.55-8.55zM32.07 38.93c.04-.9.04-1.8.01-2.7l.94-.95 19.82-19.82h2.7zM26.27 15.45l-.69.69c-.08-.13-.17-.26-.26-.39-.08-.1-.15-.21-.2-.3z"
				opacity={0.5}
			/>
			<path
				fill="#000"
				d="M71.55 60.73c-.34.4-1.01.72-1.48.72h-18.1c-2.25 0-2.61-1.53-1.18-3.6 8.57-12.25 8.57-28.65 0-40.9-1.43-2.07-1.07-3.6 1.18-3.6h18.1c.47 0 1.14.32 1.48.72 11.55 13.39 11.55 33.26 0 46.65z"
			/>
			<path
				fill="#fff"
				d="M69.95 15.36s.08.04.1.06a33.7 33.7 0 0 1 8.15 21.99c0 8.07-2.9 15.88-8.15 21.99-.03.02-.07.04-.1.06H24.96c.07-.13.16-.28.28-.45 9.04-12.92 9.04-30.27 0-43.18-.12-.17-.21-.33-.28-.46h44.99m.11-2.01H24.78c-2.25 0-2.61 1.53-1.18 3.6 8.57 12.25 8.57 28.65 0 40.9-1.43 2.07-1.07 3.6 1.18 3.6h45.28c.47 0 1.14-.32 1.48-.72 11.55-13.39 11.55-33.26 0-46.65-.34-.4-1.01-.72-1.48-.72z"
			/>
		</svg>
	);
}
